import _                                           from 'underscore';
import React, { FC, MutableRefObject, useContext } from 'react';
import { Switch, useHistory, useParams }           from 'react-router-dom';

import { RouterUtility }             from '../../../util';
import { OrganizationAccessControl } from '../../components/util/access/RoleAccessControl';
import { PrivateRoute }              from '../../components/util/routing/PrivateRoute';

import { UserProfilePage }            from './profile/UserProfilePage';
import { useCurrentUser }             from '../../../hooks';
import { RouterLocationParams, Uuid } from '../../../types';
import { RolePolicyType }             from '../../../services/RoleAccessService';

export interface UserContextType {
	organizationId: Uuid,
	accountId: Uuid
}

export const UserContext: React.Context<UserContextType> = React.createContext( { organizationId: null, accountId: null } );

const UserContextValues: MutableRefObject<UserContextType | null> = React.createRef();

const routeTo    = RouterUtility.getRoutePath,
      routePaths = {
	      noAccess: `${ routeTo( 'DASHBOARD' ) }`,
	      profile:  `${ routeTo( 'USERS.PROFILE' ) }`,
      };

const UserIndexPage: FC = ( props ) => {
	
	let history = useHistory(),
	    params  = useParams<RouterLocationParams.UserProfile>();
	
	let { currentUser } = useCurrentUser(),
	    organizationId  = params.organizationId,
	    accountId       = params.accountId;
	
	// get the specific project from the current user account
	let memberOrganization = _.findWhere( currentUser.organizations, { organizationId } );
	
	// no project id given, or no project found on account
	if( !accountId || !organizationId || !memberOrganization ){
		history.replace( routePaths.noAccess )
	}
	
	// set up role access control props w/ user's context object
	// so we dont need to keep specifying account / org,
	// otherwise we'd need to speciy id's on each control
	let accessProps = {
		redirect: routePaths.noAccess,
		organizationId,
	};
	
	UserContextValues.current = {
		organizationId,
		accountId,
	};
	
	return (
		<UserContext.Provider value={ UserContextValues.current }>
			
			<OrganizationAccessControl policies={ [ RolePolicyType.USER_ACCESS ] } { ...accessProps } redirect={ routePaths.noAccess }>
				
				<Switch>
					
					<PrivateRoute path={ routePaths.profile } component={ ( props: any ) => (
						<OrganizationAccessControl policies={ [ RolePolicyType.USER_PROFILE_VIEW ] } { ...accessProps }>
							<UserProfilePage { ...props } />
						</OrganizationAccessControl>
					) }/>
				
				</Switch>
			
			</OrganizationAccessControl>
		
		</UserContext.Provider>
	)
};

export default UserIndexPage;
